<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-4">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                <td>
                  <flat-pickr @on-change="onChange" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                  <option :value="null">Please select</option>
                  <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-4 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input @keyup.enter="enterClicked(searchData)" class="form-control" placeholder="Search" type="text"
                         v-model="searchData">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table :bordered="bordered" :current-page="currentPage" :fields="fields" :fixed="fixed" :hover="hover"
                 :items="items" :small="small" :striped="striped" @sort-changed="sortingChanged" responsive>
          <template v-slot:cell(form_type)="data">
            Cancel
          </template>
<!--          <template slot="name" slot-scope="data" v-if="data.item.member">-->
          <template v-slot:cell(name)="data">
            <template v-if="data.item.member">
              {{data.item.member.first_name}} {{data.item.member.last_name}}
            </template>
          </template>
          <template v-slot:cell(date)="data">
            {{ data.item.effective_date | moment('DD MMMM YYYY')}}
          </template>
          <template v-slot:cell(time)="data">
            {{data.item.created_at | moment('h:mm a')}}

          </template>
          <template v-slot:cell(cancel_category)="data">
            {{data.item.cancellation_category == null ? '-' : data.item.cancellation_category.name}}

          </template>
          <template v-slot:cell(revenue)="data">
            {{data.item.revenue | toRupiah}}
          </template>
          <template v-slot:cell(created_at)="data">
            {{data.item.created_at | moment('DD MMMM YYYY')}}
          </template>
          <template v-slot:cell(actions)="data">
            <b-button @click="editForm('/allForm/editCancel?id=' + data.item.id)" class="btn-table warning mr-1" size="sm">
              <i class="far fa-edit"></i> Edit
            </b-button>
          </template>
        </b-table>
        <app-pagination :current-page="currentPage" :total-pages="totalPage"
                        @page-changed="pageOneChanged"
                        class="pagination-custom mt-20"
                        next-text="Next" prev-text="Prev"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {Callout} from '@coreui/vue'
  import moment from 'moment'
  import axios from 'axios'
  import {Auth} from '@/api'
  import Pagination from '@/views/component/pagination'

  moment.locale('en')

  export default {
    name: 'allForm',
    components: {
      'app-pagination': Pagination
    },
    props: {
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: true
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        fields: [
          {
            key: 'form_type',
            label: 'Type Form',
            sortable: true
          },
          {
            key: 'member_id',
            label: 'Member ID',
            sortable: true
          },
          {
            key: 'branch.name',
            label: 'Branch Name',
            sortable: true
          },
          {
            key: 'name',
            label: 'Member Name',
            sortable: true
          },
          {
            key: 'member.phone_number',
            label: 'Phone Number',
            sortable: true
          },
          {
            key: 'member.start_membership',
            label: 'Start Membership',
            sortable: true,
            formatter: (value, key, item) => {
              return moment(item.member.start_membership).format('DD MMMM YYYY')
            }
          },
          {
            key: 'member.membership_last_buy_name',
            label: 'Membership Type',
            sortable: true
          },
          {
            key: 'customer_service.name',
            label: 'Customer Service',
            sortable: true
          },
          {
            key: 'date',
            label: 'Effective Date Cancellation',
            sortable: true
          },
          {
            key: 'created_at',
            label: 'Date',
            sortable: true
          },
          {
            key: 'time',
            label: 'Time',
            sortable: true
          },
          {
            key: 'detail_reason',
            label: 'Reason',
            sortable: true
          },
          {
            key: 'revenue',
            label: 'Amount',
            sortable: true
          },
          {
            key: 'cancel_category',
            label: 'Cancel Category',
            sortable: true
          },
          {
            key: 'actions',
            label: 'Action'
          }
        ],
        items: [],
        dataBranch: [],
        branch_id: null,
        getId: Auth.Session.get().paradigm_id,
        exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
        exportConfig: {
          mode: "range",
          dateFormat: "Y-m-d",
          altInput: true,
          altFormat: "d/m/y",
          defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
        },
        sortType: '',
        sortBy: '',
        searchData: '',
        currentPage: 1,
        paginationLimit: 10,
        totalPage: 0
      }
    },
    computed: {
      name() {
        return this.$route.name
      }
    },
    methods: {
      onChange(selectedDates, dateStr, instance) {
        // console.log('test2', dateStr)
        if(selectedDates.length === 2){
            if(typeof selectedDates[0] === typeof selectedDates[1]){
                this.exportDates = dateStr + ' to ' + dateStr
            }else{
                this.exportDates = dateStr
            }
            if(this.exportDates.includes(" to ") === true) {
                this.fetchData()
            }
        }
      },
      exportReport() {
        let dates = this.exportDates.split(' to ')
        let url = 'crm/v1/export/cancellation_report?start_date='+dates[0]+'&end_date='+dates[1]

        if (this.branch_id != null) {
          url += '&branch_id=' + this.branch_id
        }

        axios({
          method: 'get',
          url: url,
          responseType: 'arraybuffer'
        }).then(response => {
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'Cancel Report '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
          link.click()
        }).catch(error => {
          console.log('error', error)
        })
      },
      parseDate(value) {
        moment.locale('en')
        return moment(value).format('DD MMMM YYYY')
      },
      parseTime(value) {
        moment.locale('en')
        return moment(value).format('h:mm a')
      },
      parseCreated(value) {
        return moment(value).format('DD MMMM YYYY')
      },
      pageOneChanged(pageNum) {
        this.currentPage = pageNum
        this.fetchData()
      },
      sortingChanged(event) {
        // console.log(event.sortDesc)
        // event.sortBy   ==> Field key for sorting by (or null for no sorting)
        // event.sortDesc ==> true if sorting descending, false otherwise
        this.sortBy = event.sortBy
        if (event.sortDesc === false) {
          this.sortType = 'asc'
          // console.log(this.sortType)
        } else {
          this.sortType = 'desc'
          // console.log(this.sortType)
        }
        this.fetchData()
      },
      enterClicked(searchEvent) {
        this.fetchData()
      },
      getBadge(status) {
        return status === 'Active' ? 'success'
          : status === 'Inactive' ? 'danger'
            : status === 'active' ? 'success'
              : status === 'inactive' ? 'danger' : 'primary'
      },
      getRowCount(items) {
        return items.length
      },
      openPage(event) {
        this.$router.push(event)
      },
      editForm(event) {
        this.$router.push(event)
      },
      showModal(id) {
        this.$refs[id].show()
      },
      changeBranch(event) {
        if (event != null) {
          this.branch_id = event
        }

        this.fetchData()
      },
      deleteForm(event) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You can\'t revert your action',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes Delete it!',
          cancelButtonText: 'No, Keep it!',
          showCloseButton: true,
          showLoaderOnConfirm: false
        }).then((result) => {
          if (result.value) {
            this.$swal('Deleted', 'You successfully deleted this file', 'success')
            axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
            axios.delete('fitness/v1/form/'.concat(event)).then(response => {
              // this.$router.go()
              this.fetchData()
            }).catch(error => {
              console.log('error', error)
            })
          } else {
            this.$swal('Cancelled', 'Your file is still intact', 'info')
          }
        })
      },
      fetchData() {
        let dates1 = this.exportDates.split(' to ')
        axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
        let url = 'crm/v1/form_cancel?page=' + this.currentPage
          + '&limit=' + this.paginationLimit
          + '&sorting=' + this.sortBy
          + '&sorting_type=' + this.sortType
          + '&keyword=' + this.searchData
          + '&start_date=' + dates1[0]
          + '&end_date=' + dates1[1]

        if (this.branch_id != null) {
          url += '&branch_id=' + this.branch_id
        }

        axios.get(url).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
        }).catch(error => {
          console.log('error', error)
        })

        axios.get('fitness/v1/branch/').then(response => {
          this.dataBranch = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    created() {
      this.fetchData()
    }
  }
</script>

<style>
</style>
